import styled, { css } from 'styled-components'

export const SC_p = styled.p.attrs(props => ({
	
}))`
	
`

export const SC_span = styled.span.attrs(props => ({
	
}))`
	
`

export const SC_h1 = styled.h1.attrs(props => ({
	
}))`
	text-align: center;
`

export const SC_h2 = styled.h2.attrs(props => ({
	
}))`
	${props => props.textAlign ? 
	`text-align: ${props.textAlign};` 
	: null }

	${props => props.hasAddOn ? 
	`display: flex;
	justify-content: space-between;` 
	: null }

	${props => props.divider == 'true' ? 
	`
	&:after {
		display: block;
		content: '';
		width: 80px;
		height: ${parseFloat(props.theme.inputBtnBorderWidth)*2}px;
		background: ${props.theme.bodyColor};
		margin: 0 auto;
		position: relative;
		top: ${props.theme.spacers[4]};
	}
	` 
	: null }
`

export const SC_h5 = styled.h5.attrs(props => ({
	
}))`
	margin-bottom: 0;
`

export const SC_div = styled.div.attrs(props => ({
	
}))`
	h2:not(:first-child), h3 {
		margin-top: ${props => props.theme.headingsMarginBottom};
	}

	li {
		margin-bottom: ${props => props.theme.paragraphMarginBottom};
	}
`



